import {
    FETCH_USER,
    FETCH_USERS,
    FETCH_LOGINED_USER,
    FETCH_USERBUYVAS,
    FETCH_USERQCOINTRANS,
    FETCH_USERCASHTRANSTYPES
} from '../actions/user';


export const initialState = {
    isFetching: true,
    data: null
};

export const users = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const user = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USER}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USER}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const loginedUser = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_LOGINED_USER}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_LOGINED_USER}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const userBuyVas = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USERBUYVAS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USERBUYVAS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const userQcoinTrans = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USERQCOINTRANS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USERQCOINTRANS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const userCashTransTypes = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USERCASHTRANSTYPES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_USERCASHTRANSTYPES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/user.js